<script lang="ts">
    
    import { onMount } from "svelte";
    import { Button, Col, Icon, Row, TabContent, TabPane } from "sveltestrap";
    import AccountManagers from "../../Components/Accounts/AccountManagers.svelte";
    import AccountRooms from "../../Components/Accounts/AccountRooms.svelte";
    import AppWrapper from "../../Components/AppWrapper.svelte";
    import InvalidFeedback from "../../Components/InvalidFeedback.svelte";
    import ManagerIcon from "../../Components/Manager/ManagerIcon.svelte";
    import RoomIcon from "../../Components/Rooms/RoomIcon.svelte";
    import Checkbox from "../../Components/Shared/Checkbox.svelte";
    import InputText from "../../Components/Shared/InputText.svelte";
    import TitleBar from "../../Components/TitleBar.svelte";
    import Watch from "../../Components/Watch.svelte";
    import type { Account } from "../../Model/Account";
    import { accountsService } from "../../Services";
    import { showNotification } from "../../Services/ui";

    export let accountId: string;

    let account: Account;
    let isSaving = false;
    let currentTab = 'form';

    onMount(mount);

    async function mount(): Promise<void> {
        account = await accountsService.getAccount(accountId);
    }

    async function onSave(): Promise<void> {
        if (isSaving) {
            return;
        }
        isSaving = true;
        try {
            await accountsService.saveAccount(account);
            showNotification({
                type: 'success',
                content: 'Los datos han sido guardados'
            });
        } catch (error) {
            console.error(error);
        } finally {
            isSaving = false;
        }
    }

    function updateCurrentTab({ detail }: CustomEvent<string>): void {
        currentTab = detail;
    }

</script>

<AppWrapper>

    <Watch state={account?.name} let:value>
        <TitleBar title={value || "Editar cuenta"}>
            {#if currentTab === 'form'}
                <Button type="button" color="primary" on:click={onSave}>
                    <Icon name="cloud-upload" /> Guardar
                </Button>
            {/if}
        </TitleBar>
    </Watch>

    <TabContent on:tab={updateCurrentTab}>

        <TabPane tabId="form" active class="pt-3">
            <span slot="tab">Cuenta</span>
            {#if account}
                <Row class="align-items-center">
                    <Col xs={12} sm={10} md={8} lg={6}>
                        <InputText label="Nombre de la cuenta" value={account.name} required let:valueMissing>
                            <InvalidFeedback show={valueMissing}>
                                Este campo es obligatorio
                            </InvalidFeedback>
                        </InputText>
                    </Col>
                    <Col xs={12} sm={10} md={4} lg={6}>
                        <Checkbox checked={account.enabled} label="Cuenta activada" />
                    </Col>
                </Row>
                <Row class="mt-3">
                    <Col>
                        <div class="mb-2"><strong>Juegos permitidos</strong></div>
                        <Checkbox checked={account.allowedGames.bingo90} label="Binfun 90" />
                        <Checkbox checked={account.allowedGames.bingo75} label="Binfun 75" />
                        <Checkbox checked={account.allowedGames.bingoMex} label="Lotería mexicana" />
                        <Checkbox checked={account.allowedGames.bingoAnimals} label="Binfun Animales" />
                        <Checkbox checked={account.allowedGames.bingoCartoon} label="Binfun Caricaturas" />
                        <Checkbox checked={account.allowedGames.movies} label="Binfun Cine" />
                        <Checkbox checked={account.allowedGames.moviesKids} label="Binfun Cine Kids" />
                        <Checkbox checked={account.allowedGames.xmas} label="Binfun X-Mas" />
                        <Checkbox checked={account.allowedGames.football} label="Binfun Football" />
                        <Checkbox checked={account.allowedGames.halloween} label="Binfun Halloween" />
                        <Checkbox checked={account.allowedGames.superheroes} label="Binfun Superheroes" />
                        <Checkbox checked={account.allowedGames.cartoon} label="Binfun Cartoon" />
                    </Col>
                </Row>
            {/if}
        </TabPane>
        
        <TabPane tabId="rooms" class="pt-3">
            <span slot="tab"><RoomIcon /> Salas</span>
            <AccountRooms {accountId} />
        </TabPane>

        <TabPane tabId="managers" class="pt-3">
            <span slot="tab"><ManagerIcon /> Animadores</span>
            <AccountManagers {accountId} />
        </TabPane>

    </TabContent>


</AppWrapper>
